<template>
  <div id="app">
    <router-view></router-view>

    <a v-if="isSpyou" href="https://api.whatsapp.com/send?phone=551130423754" class="wpp">
      <img src="@/assets/images/pages/whatsapp.svg" alt="Logo" style="width: 50%; height: 50%" />
    </a>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';

export default {
  data() {
    return {
      isSpyou: false
    };
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    }
  },
  methods: {
    checkIfSpyou() {
      return process.env.VUE_APP_NAME === 'spyou cloud';
    },
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    }
  },
  mounted() {
    this.isSpyou = this.checkIfSpyou();
    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });

    this.$store.dispatch('updateWindowWidth', window.innerWidth);

    setTimeout(() => {
      this.$EventBus.$emit('userChanged');
    }, 100);

    this.$EventBus.$on('userChanged', () => {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      if (userId && token) {
        window.Echo.connector.options.auth.headers['Authorization'] = `Bearer ${token}`;
        window.Echo.options.auth = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        };
        window.Echo.leave(`mobile.${userId}`);
        window.Echo.private(`mobile.${userId}`).listen('MobileUpdate', payload => {
          if (window.location.href.indexOf('checkout') === -1) {
            this.$notification.show(
              (payload.alias || payload.device).replace(/(<([^>]+)>)/gi, ''),
              {
                body: payload.message.replace(/(<([^>]+)>)/gi, '')
              },
              {}
            );

            this.$vs.notify({
              time: 10000,
              title: payload.alias || payload.device,
              text: payload.message,
              iconPack: 'feather',
              icon: 'icon-smartphone',
              color: 'primary',
              position: 'top-center'
            });
          }
        });
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
};
</script>

<style>
.wpp {
  width: 60px;
  height: 60px;
  background-color: #4ff56b;
  border-radius: 100%;
  position: fixed;
  right: 20px;
  bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
